module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-05-b844943ffb55b65b78eedb815668bf6d.svg";